import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import Slide from '@material-ui/core/Slide'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import CloseIcon from '@material-ui/icons/Close'
import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/users'
import { edit, update } from '../RolesAction'
import Form from './Form'

function Transition(props) {
  return <Slide direction="down" {...props} />
}

function EditRole(props) {
  const { classes } = props
  const permissions = useSelector(state => state.role.permissions)
  const dispatch = useDispatch()
  const see = props.match.params.see

  useEffect(() => {
    dispatch(edit(props.match.params.id))
  }, []);

  const role = useSelector(state => state.role.editingRole)

  const onSubmit = values => {
    dispatch(update(values)).then(data => {
      if (data && data.code === 200) {
        props.history.push('/roles')
      }
    })
  }

  const onClose = () => {
    props.history.push('/roles')
  }

  return (
    <Dialog
      open={role !== null}
      fullScreen
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" className={classes.flex}>
            {`${see ? 'Visualizar' : 'Editar'} Regra`}
          </Typography>
          <IconButton
            color="inherit"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Form data={role} see={see} permissions={permissions} onClose={onClose} onSubmit={onSubmit} />
    </Dialog>
  )
}

EditRole.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default (withStyles(styles)(EditRole))
